import { render, staticRenderFns } from "./DsButton.vue?vue&type=template&id=df8a66c0&scoped=true&"
import script from "./DsButton.vue?vue&type=script&lang=js&"
export * from "./DsButton.vue?vue&type=script&lang=js&"
import style0 from "./DsButton.vue?vue&type=style&index=0&id=df8a66c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8a66c0",
  null
  
)

export default component.exports